import { IdType, Row } from "react-table";

export const getFilterDefaultValues = <T extends object>(
  preFilteredRows: Row<T>[],
  preFilteredValues: string[] = [],
  name?: IdType<T>
): string[] => {
  const defaultValues = new Set<string>(preFilteredValues);

  preFilteredRows?.forEach((row) => {
    if (row.values[name!] && Array.isArray(row.values[name!]))
      row.values[name!].forEach((value: string) => {
        defaultValues.add(value);
      });
  });

  return Array.from(defaultValues);
};

export default getFilterDefaultValues;
